import styled from 'styled-components';

const PortfolioBoxContainer = styled.div`
    overflow: hidden;
    position: relative;
    @media (min-width: 768px) {
        flex-basis: 50%;
    }
    @media (min-width: 1199px) {
        flex-basis: 25%;
    }
    &:hover .caption {
        bottom: 0;
    }
    &:hover img {
        transform: rotate(3deg) scale(1.1);
    }
    img {
        max-width: 100%;
        transition: 0.3s;
    }
    .caption {
        position: absolute;
        left: 0;
        padding: 20px;
        background-color: white;
        width: 100%;
        transition: 0.3s;
        bottom: -100%;
        h4 {
            font-weight: normal;
            margin-bottom: 10px;
        }
        p {
            color: var(--main-color);
        }
    }
`;

export default PortfolioBoxContainer;
